import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ResellerCommissionsResponse } from "../../resellers.types";
import { requestGetResellerCommissions } from "./getResellerCommissions.request";
import { GetResellerCommissionsRequestParams } from "./getResellerCommissions.types";

const useGetResellerCommissions = (
  resellerId: string,
  requestParams: GetResellerCommissionsRequestParams,
  options?: QueryOptions<
    ResellerCommissionsResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", resellerId, "commissions", requestParams],
    queryFn: async () =>
      await requestGetResellerCommissions(resellerId, requestParams),
    enabled: !!resellerId,
    keepPreviousData: true,
    ...options
  });

  return {
    commissions: data?.data,
    meta: data?.meta,
    summary: data?.summary,
    shownTotal: data?.shownTotal,
    ...rest
  };
};

export default useGetResellerCommissions;
